// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[type=checkbox][data-v-0b3cfb26],input[type=radio][data-v-0b3cfb26]{width:15px;height:15px}[data-v-0b3cfb26] a{text-decoration:underline;--text-opacity:1;color:#ff7913;color:rgba(255,121,19,var(--text-opacity));cursor:pointer}", ""]);
// Exports
module.exports = exports;
